<template>
  <el-dialog
    :visible.sync="dialogVisible"
    title="请确认您的操作!"
    width="30%"
    @close="closeDialog"
  >
    <div style="text-align:center">
      <p>确定删除审核人员</p>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">点错了</el-button>
      <el-button type="primary" @click="deleteAuditUser">确认删除</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { deleteAuditUser } from '@/api/common/auditUserApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'DeleteAuditUser',
  data() {
    return {
      dialogVisible: false,
      currentAuditUser: {}
    }
  },
  methods: {
    open(auditUser) {
      this.currentAuditUser = auditUser
      this.dialogVisible = true
    },
    closeDialog() {
      this.dialogVisible = false
    },
    async deleteAuditUser() {
      try {
        const params = {
          ...this.currentAuditUser,
          shopId: getShopId()
        }
        await deleteAuditUser(params)
        this.$message.success('删除成功')
        this.closeDialog()
        this.$emit('refresh')
      } catch (error) {
        console.error('删除失败:', error)
        this.$message.error('删除失败')
      }
    }
  }
}
</script>